enum ContainerValueType {
  BIND = 'bind',
  SINGLETON = 'singleton'
}

export class Container {
  private registry: Map<string, unknown> = new Map<string, unknown>();

  // eslint-disable-next-line @typescript-eslint/ban-types
  public bind<T>(key: Function, value: (container: Container, ...args: unknown[]) => T): void {
    this.registry.set(this.getTokenizedKey(key), {
      key: ContainerValueType.BIND,
      value
    });
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  public singleton<T>(key: Function, value: (container: Container, ...args: unknown[]) => T): void {
    this.registry.set(this.getTokenizedKey(key), {
      key: ContainerValueType.SINGLETON,
      value
    });
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  public resolve<T>(key: Function, ...args: unknown[]): T | undefined {
    const classType: {
      key: ContainerValueType;
      value: (container: Container) => T;
    } = this.registry.get(this.getTokenizedKey(key)) as {
      key: ContainerValueType;
      value: (container: Container) => T;
    };

    if (!classType) {
      // @ts-ignore
      return new key(...args);
    }

    if (classType && classType.key === ContainerValueType.SINGLETON) {
      // @ts-ignore
      const instance: T = classType.value(this, ...args);
      this.bind(key, () => instance);

      return instance;
    }

    // @ts-ignore
    return classType.value(this, ...args);
  }

  public clear(): void {
    this.registry.clear();
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  private getTokenizedKey(key: Function): string {
    return `${key.name}:${key}`;
  }
}

export default new Container();
